module.exports = __webpack_public_path__ + "static/pepperreport-309b33ef98727f05c01986335f78264f.pdf";